import React from 'react';

/**
 * TacticalCard - Tactical Precision UI Component
 *
 * Variants: default, interactive, selected, critical
 * Slots: eyebrow, title, metadata, children (content), actions, footer
 *
 * Used for mission cards, info panels, content blocks
 */
export const TacticalCard = ({
  children,
  variant = 'default',
  eyebrow,
  title,
  metadata,
  actions,
  footer,
  onClick,
  className = '',
  ...props
}) => {
  const baseClass = 'tp-card';
  const variantClass = `tp-card--${variant}`;
  const interactiveClass = onClick ? 'tp-card--clickable' : '';

  const handleClick = (e) => {
    if (onClick) {
      onClick(e);
    }
  };

  const handleKeyDown = (e) => {
    if (onClick && (e.key === 'Enter' || e.key === ' ')) {
      e.preventDefault();
      onClick(e);
    }
  };

  return (
    <div
      className={`${baseClass} ${variantClass} ${interactiveClass} ${className}`.trim()}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      tabIndex={onClick ? 0 : undefined}
      role={onClick ? 'button' : undefined}
      {...props}
    >
      {eyebrow && (
        <div className="tp-card__eyebrow">{eyebrow}</div>
      )}

      {title && (
        <div className="tp-card__header">
          <h3 className="tp-card__title">{title}</h3>
        </div>
      )}

      {metadata && (
        <div className="tp-card__metadata">{metadata}</div>
      )}

      {children && (
        <div className="tp-card__content">{children}</div>
      )}

      {actions && (
        <div className="tp-card__actions">{actions}</div>
      )}

      {footer && (
        <div className="tp-card__footer">{footer}</div>
      )}
    </div>
  );
};

export default TacticalCard;
